import * as _ from 'lodash';
import { PageBase, PageOptionsBase } from '../../Common/PageBase';
import { DatatableApi, Datatable, DatatableOptions } from '../../Widgets/Datatable'
import { MultiSelectApi } from '../../Widgets/MultiSelect'
import { Utils } from '../../Utils/Utils';
import { DateUtils } from '../../Utils/DateUtils';
import { StringUtils } from '../../Utils/StringUtils';

var tableId = 'tableSelectedConfigurationKeys';
var tableDom = "<'row'<'col-sm-6'l><'col-sm-6'><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";

export interface SelectedConfigurationKeysPageOptions extends PageOptionsBase {
    urlList: string;
    urlDetail: string;
    urlPost: string;
    localizer: {
        StatusEnabled: string;
        StatusDisabled: string;
    }
}

export class SelectedConfigurationKeys extends PageBase<SelectedConfigurationKeysPageOptions> {
    private _tableOptions: DatatableOptions;
    private _table: Datatable;
    private _btnRemoveFromExport: JQuery;
    private _checkAll: JQuery;
    private _otherCheckAll: JQuery;

    constructor(options: SelectedConfigurationKeysPageOptions) {
        super(options);
        this.removeFromExport = this.removeFromExport.bind(this);
        this.checkBoxAll = this.checkBoxAll.bind(this);
        window['setSelectAllCheckbox'] = this.setSelectAllCheckbox;

        this._tableOptions = {
            url: this._options.urlList,
            dom: tableDom,
            rowId: 'Code',
            order: [1, "asc"],
            autoWidth: true,
            columns: [
                {
                    sortable: false,
                    render: (data: any, type: any, rowData: any) => {
                        return (`<input id='chckbx${rowData.Code}' name='keyToRemove' value='${rowData.Code}' type='checkbox' onClick="setSelectAllCheckbox()" />`);
                    }
                },
                {
                    sortable: false,
                    data: "Code"
                },
                {
                    sortable: false,
                    data: "DisplayName"
                }
            ]
        };
    }

    init(): void {
        this._btnRemoveFromExport = Utils.getJQueryById("btnRemoveFromExport");
        this._btnRemoveFromExport.on("click", this.removeFromExport);
        this._checkAll = Utils.getJQueryById("selectedKeysSelectAll");
        this._checkAll.on("change", this.checkBoxAll);
        this._otherCheckAll = Utils.getJQueryById("keysSelectAll");
        this._table = new Datatable(tableId, this._tableOptions);
    }

    private removeFromExport(e: JQueryEventObject): void {
        e.preventDefault();
        var urlPost = this._options.urlPost;
        var table = this._table;
        var keysTable = Utils.getJQueryById("tableConfigurationKeys").DataTable();
        var codes = $("input[name='keyToRemove']:checked").map(function () {
            return $(this).val();
        });
        var codesToAdd = codes.get();
        if (!codesToAdd || codesToAdd.length === 0) {
            return;
        }
        var checkAll = this._checkAll;
        var otherCheckAll = this._otherCheckAll;
        $.ajax({
            url: urlPost,
            type: "POST",
            dataType: 'html',
            data: { codes: codesToAdd },
            success: function (data) {
                checkAll.prop("checked", false);
                otherCheckAll.prop("checked", false);
                table.draw();
                keysTable.draw();
            }
        });
    }

    private checkBoxAll(): void {
        var checkboxes = $("input[name='keyToRemove']");
        for (var i = 0; i < checkboxes.length; i++) {
            (<HTMLInputElement>checkboxes[i]).checked = (<HTMLInputElement>this._checkAll[0]).checked;
        }
    }

    private setSelectAllCheckbox(): void {
        var checkboxes = $("input[name='keyToRemove']");
        let buildSelectAll = Utils.getJQueryById("selectedKeysSelectAll")[0];
        if (Utils.isNullOrUndefined(buildSelectAll))
            return;
        let allCheckboxesChecked = false;
        for (var i = 0; i < checkboxes.length; i++) {
            allCheckboxesChecked = (<HTMLInputElement>checkboxes[i]).checked;
            if (!allCheckboxesChecked)
                break;
        }
        (<HTMLInputElement>buildSelectAll).checked = allCheckboxesChecked;
    }
}


/** WEBPACK FOOTER **
 ** ./Typescript/Pages/ConfigurationOverview/SelectedConfigurationKeys.ts
 **/